import {BolaoRouteMetaDataModel} from "./bolao-route.meta-data.model";
import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";
import {ROUTE_NAMES} from "../../../core/consts";
import {BolaoContainerPlaceholder} from "../components/bolao-container.placeholder";

export class BolaoRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor(props) {
    super(props);

    this.name = ROUTE_NAMES.bolao;
    this.path = `/bolao/:filter?/:id?`;
    this.paths = [
      "/bolao/:filter/:id",
      "/bolao/:filter",
      "/bolao"
    ];
    this.component = ReactLazyPreload(() => import("../components/bolao-container" /* webpackChunkName: "bolao-container" */ ));
    this.metadataType = BolaoRouteMetaDataModel;
    this.PlaceholderComponent = BolaoContainerPlaceholder;
  }
}
